import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getCookie } from '../helpers/utils';

const API_URL = (tournament_id: number) => `/api/tournament/${tournament_id}/players`;
const PLAYERS_API_URL = `/api/v1/player/`;
const TOURNAMENT_PLAYERS_API_URL = `/api/v1/tournament_player/`;
const TOURNAMENTS_LIST_API_URL_BASE = '/api/tournaments/';
const PLAYER_STATS_API_URL_BASE = '/api/v1/player_stats/';
const PLAYER_VIDEO_API_URL_BASE = '/api/v1/player_video/';

@Injectable({
  providedIn: 'root',
})
export class PlayersService {

  private _playerId: number;
  constructor(private http: HttpClient) {}

  private getCsrfToken(): string {
    return getCookie('csrftoken');
  }

  get(tournament_id: number) {
    return this.http.get(API_URL(tournament_id));
  }

  getAllPlayers() {
    return this.http.get(PLAYERS_API_URL);
  }

  getPlayersToDisplay(
    page: number,
    page_size: number,
    orderBy?: string,
    orderType?: string
  ) {
    if (orderType) {
      return this.http.get(`${PLAYERS_API_URL}?page=${page}&page_size=${page_size}&order_by=${orderBy}&order_type=${orderType}`);
    }
    return this.http.get(PLAYERS_API_URL + '?page=' + page + '&page_size=' + page_size);
  }

  private action(tournament_id: number, action: string, data: any) {
    return this.http.post(
      API_URL(tournament_id),
      {
        action,
        ...data,
      },
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        },
      }
    );
  }

  updateTournamentNumbers(tournament_id: number, players: any[]) {
    return this.http.patch(
      API_URL(tournament_id),
      {
        players,
      },
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        },
      }
    );
  }

  addPlayer(tournament_id: number, player_id: number) {
    return this.action(tournament_id, 'add_player', {
      player_id,
    });
  }

  removePlayer(tournament_id: number, player_id: number) {
    return this.action(tournament_id, 'remove_player', {
      player_id,
    });
  }

  lottery(tournament_id: number, type?: string) {
    return this.action(tournament_id, 'lottery', {
      type,
    });
  }

  resetLottery(tournament_id: number) {
    return this.action(tournament_id, 'reset_lottery', {});
  }

  create_groups(tournament_id: number) {
    return this.action(tournament_id, 'create_groups', {});
  }

  create_brackets(tournament_id: number) {
    return this.action(tournament_id, 'create_brackets', {});
  }

  search(query: string, tournament_id?: number | string) {
    const paramsObject = {
      search: query,
    };

    if (typeof tournament_id === 'number' || typeof tournament_id === 'string'){
      paramsObject['tournament_id'] = tournament_id;
    }

    return this.http.get(PLAYERS_API_URL, {
      params: paramsObject
    });
  }

  createPlayer(player: any) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(player)) {
      if (key === 'city') {
        const json = JSON.stringify(value);
        const blob = new Blob([json], {
          type: 'application/json',
        });
        formData.append(key, blob);
      } else {
        formData.append(key, value as Blob);
      }
    }
    console.log(formData);

    return this.http.post(
      PLAYERS_API_URL,
      /* {
        ...player,
      }, */
      formData,
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        },
      }
    );
  }

  getPlayer(id: number) {
    return this.http.get(`${PLAYERS_API_URL}${id}/`);
  }

  update(id: number, player: any) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(player)) {
      if (key === 'city') {
        const json = JSON.stringify(value);
        const blob = new Blob([json], {
          type: 'application/json',
        });
        formData.append(key, blob);
      } else {
        formData.append(key, value as Blob);
      }
    }
    console.log(formData);

    return this.http.put(
      `${PLAYERS_API_URL}${id}/`,
      /* {
        ...player,
      }, */
      formData,
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        },
      }
    );
  }

  getPlayerStats() {
    return this.http.get(`${TOURNAMENTS_LIST_API_URL_BASE}${this.playerId}`);
  }

  get playerId(): number {
    return this._playerId;
  }

  set playerId(value){
    this._playerId = value;
  }

  getPlayerSummaryStats() {
    return this.http.get(`${PLAYER_STATS_API_URL_BASE}${this.playerId}`);
  }

  getPlayerVideo() {
    return this.http.get(`${PLAYER_VIDEO_API_URL_BASE}${this.playerId}`);
  }
}
